'use client';

import { useAppStore } from '@/store/app';
import { translate } from '@/lib/i18n';

/** D01 metric info popover: shows name, methodology and unit on hover/focus. */
export default function MetricInfoPopover({
  metricId,
  unit,
  children,
}: {
  metricId: string;
  unit?: string;
  children: React.ReactNode;
}) {
  const { language } = useAppStore();
  const t = translate(language);
  const nameKey = `metric${metricId
    .split('_')
    .map((s) => s[0].toUpperCase() + s.slice(1))
    .join('')}` as keyof typeof t.research;
  const descKey = `${String(nameKey)}Desc` as keyof typeof t.research;
  const name = (t.research[nameKey] as string) ?? metricId;
  const desc = (t.research[descKey] as string) ?? '';

  return (
    <span className="group relative inline-flex items-center">
      {children}
      <span className="pointer-events-none absolute bottom-full left-0 z-30 mb-1.5 hidden w-52 rounded-lg border border-gf-border bg-[rgb(var(--gf-card))] p-2.5 text-left shadow-xl group-hover:block group-focus-within:block">
        <div className="mb-1 flex items-center justify-between gap-2">
          <span className="text-xs font-bold">{name}</span>
          {unit ? <span className="rounded bg-gf-border/40 px-1 text-[10px] text-gf-muted">{unit}</span> : null}
        </div>
        <p className="text-[11px] leading-4 text-gf-muted">{desc || metricId}</p>
      </span>
    </span>
  );
}
